import menu from './img/menu.png'
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import translate from './translate/header.json';

const MobileHeader = ({logOut}) => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
        document.body.style.overflow = 'hidden';
    };
  
    const closeModal = () => {
        setIsModalOpen(false);
        document.body.style.overflow = 'auto';
      };
  
    const handleEscKey = (event) => {
        if (event.key === 'Escape') {
          closeModal();
        }
    };
    const closeOnOutsideClick = (e) => {
        if (isModalOpen && !e.target.closest('.user-btn-menu')) {
          closeModal();
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleEscKey);
        document.addEventListener('click', closeOnOutsideClick);
        return () => {
          document.removeEventListener('keydown', handleEscKey);
          document.removeEventListener('click', closeOnOutsideClick);
        }
    });
    return <div className='mobile-header'>
        <button className="user-btn-menu" onClick={() => openModal()}>
          <img src={menu} alt="menu" className='user-btn-menu-img'/>
        </button> 

        {isModalOpen && (
          <div className="user-modal-overlay">
              <div className="menu user-modal-content">
                  <button className='user-nav-menu-btns' onClick={() => {navigate("../balance"); closeModal()}}>{translate.name1[JSON.parse(localStorage.getItem('choosen-language'))]}</button>
                  <button className='user-nav-menu-btns' onClick={() => {navigate("../profile"); closeModal()}}>{translate.name2[JSON.parse(localStorage.getItem('choosen-language'))]}</button>
                  <hr width="100%" color="#FAFAFA" />
                  <button className='user-nav-menu-btns' onClick={() => {navigate('/login'); logOut(); closeModal();}}>Logout</button>
              </div>
          </div>
        )}
    </div>
}

export default MobileHeader;